(function (window, undefined) {
  'use strict';

  angular.module('cbl.finanza.mf').service('CashflowSrvc', [
    '$http',
    '$state',
    'FinUserSrvc',
    'FIN_CONSTANTS',
    function ($http, $state, finUserSrvc, CONSTANTS) {
      /**
       * @ngdoc method
       * @name promiseCustomerData
       * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
       * @description Effettua la chiamata per ricevere il customerdata
       * @return {Promise} - Ritorna una promise contenente il customerdata
       */
      this.promiseCustomerData = function (rapporto) {
        return $http({
          method: 'GET',
          url: CONSTANTS.REST_CUSTOMER + CONSTANTS.REST.CUSTOMER_DOSSIER,
          params: {
            rapporto: rapporto
          }
        });
      };

      this.promiseFilterNdg = function (rapporto) {
        debugger;
        return $http({
          method: 'GET',
          url:
            CONSTANTS.REST_ROOT +
            CONSTANTS.REST.DOSSIER +
            'ndgDossier/' +
            rapporto,
          params: {}
        });
      };

      this.promiseGetCashflow = function (rapporti, dataInizio, dataFine) {
        return $http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.DOSSIER + 'cashflow',
          params: {
            rapporti: rapporti,
            dataInizio: dataInizio,
            dataFine: dataFine
          }
        });
      };

      this.elaboraLista = function (lista) {
        return lista;
      };
    }
  ]);
})(window);



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/cashflow/cashflow.srvc.js
 ** module id = 51
 ** module chunks = 1 2
 **/